import Vue from 'vue';
import sockets from '../../scripts/pusher.js';

const state = {
  token: null,
  profile: null,
  appVersion: null
}

const getters = {
  
  profile (state) {
    return state.profile;
  },

  token (state) {
    return state.token;
  },

  appVersion (state) {
    return state.appVersion;
  }
}

const mutations = {
  
  storeToken (state, token) {
    Vue.set(state, 'token', token);
    localStorage.setItem('token', JSON.stringify(state.token));
    window.server.defaults.headers.common['Authorization'] = 'bearer ' + state.token.access_token;
  },
  
  storeProfile (state, profile) {
    Vue.set(state, 'profile', profile);
  },

  storeAppVersion (state, version) {
    Vue.set(state, 'appVersion', version);
  },

  clearToken (state) {
    if (localStorage.token) delete localStorage.token;     
    state.token = null;
  },

  clearProfile (state, profile) {
    state.profile = false;
  },

}

const actions = {

  login ({commit, dispatch}, params) {
      
    return window.server.postReq('oauth/token2', {
      grant_type: 'password',
      username: params.username,
      password: params.password
    })
    .then(data => {
      commit('storeToken', data);
      return dispatch('fetchProfile');
    })
    .catch(e => {
      console.log('store - actions.Login Error:', e);
      return reject(e.data);
    });
  },

  signout ({commit, dispatch, state}) {
    
    var token = state.token.access_token;

    window.AppData.clearLocalStorage();
    dispatch('clearStore');

    return window.server.delReq('/oauth/token', {
      accessToken: token
    })
    .then(data => {
      sockets.disconnect();

      return Promise.resolve(data);
    })
    .catch(e => {
      console.log('store - actions.Logout Error:', e);
      return Promise.reject(e);
    });
  },

  forgotPassword ({commit, dispatch}, params) {
    return new Promise((resolve, reject) => {

      if (!params.email) {
        return reject('state.email - forgot Password - Missing required param "email"', params);
      }
    
      return window.server.post('/account/password/forgot', {
        email: params.email
      })
      .then(res => {

        return resolve();
      })
      .catch(e => {
        console.log('store - actions.forgotPassword Error:', e);
        return reject(e.data);
      });
    });
  },

  fetchProfile ({commit, dispatch, state}) {

    return window.server.getReq('/account/appVersion')
    .then(data => {
      
      commit('storeAppVersion', data);

      return window.server.getReq('/account', {
        params: {
          populateUnit: true,
          populateProperty: true,
          populateCompany: true
        }
      });
    })
    .then(data => {
      var result = storeData(data);
      commit('storeProperties', result.properties);
      commit('storeUnits', result.units);
      commit('storeRoles', result.roles);
      commit('storeProfile', result.profile);

      sockets.connect();

      return Promise.resolve(data);
    }) 
    .catch(e => {
      console.log('store - actions.fetchProfile Error:', e);
      return Promise.reject(e);
    });
  },

  registerPush ({commit, dispatch}, params) {

    if (!params.type) {
      return Promise.reject('state.registerPush - Missing required param "type" (expects "gcm" or "apn")', params);
    }
    else if (!params.token) {
      return Promise.reject('state.registerPush - Missing required param "token"', params);
    }
    
    return window.server.postReq('/account/push/register', {
      pushToken: {
        token: params.token,
        type: params.type
      }
    })
    .then(data => {
      return Promise.resolve(data);
    }) 
    .catch(e => {
      console.log('store - actions.registerPush Error:', e);
      return Promise.reject(e);
    });
  },

  unregisterPush ({commit, dispatch}, params) {

    if (!params.type) {
      return Promise.reject('state.registerPush - Missing required param "type" (expects "gcm" or "apn")', params);
    }
    else if (!params.token) {
      return Promise.reject('state.registerPush - Missing required param "token"', params);
    }
    
    return window.server.postReq('/account/push/unregister', {
      token: params.token,
      type: params.type
    })
    .then(data => {
      return Promise.resolve(data);
    }) 
    .catch(e => {
      console.log('store - actions.unregisterPush Error:', e);
      return Promise.reject(e);
    });
  },

  saveProfile ({commit, dispatch}, params) {
    
    if (!params.user) {
      return Promise.reject('state.user - update User - Missing required param "user"', params);
    }
  
    return window.server.putReq('/account', {
      user: params.user
    })
    .then(data => {
      return dispatch('fetchProfile');
    }) 
    .catch(e => {
      console.log('store - actions.saveProfile Error:', e);
      return Promise.reject(e);
    });
    
  },

  changeEmail ({commit, dispatch}, params) {
    
    if (!params.email) {
      return Promise.reject('state.email - change Email - Missing required param "email"', params);
    }
    
    return window.server.postReq('/account/email', {
      email: params.email
    })
    .then(data => {
      return Promise.resolve(data);
    }) 
    .catch(e => {
      console.log('store - actions.changeEmail Error:', e);
      return Promise.reject(e);
    });
  },

  saveNotificationSettings ({commit, dispatch}, params) {
    
    if (!params.notificationSettings) {
      return Promise.reject('state.notificationSettings - change Notification Settings - Missing required param "notificationSettings"', params);
    }
    
    return window.server.putReq('/account/notification/settings', {
      notificationSettings: params.notificationSettings
    })
    .then(data => {
      return Promise.resolve(dispatch('fetchProfile'));
    }) 
    .catch(e => {
      console.log('store - actions.notificationSettings Error:', e);
      return Promise.reject(e);
    });
    
  },

  saveNotificationSchedule ({commit, dispatch}, params) {
    
    if (!params.notificationSettings) {
      return Promise.reject('state.notificationSchedule - change Notification Schedule - Missing required param "notificationSettings"', params);
    }
    
    return window.server.putReq('/account/notification/schedule', {
      notificationSettings: params.notificationSettings
    })
    .then(data => {
      return Promise.resolve(dispatch('fetchProfile'));
    }) 
    .catch(e => {
      console.log('store - actions.notificationSchedule Error:', e);
      return Promise.reject(e);
    });
    
  }
};

export default {
  state,
  getters, 
  mutations,
  actions
}

function storeData (profile) {

  // Break out and store what we can
  var units       = {};
  var properties  = {};
  var roles       = {};


  profile.roles.forEach((role, j) => {
    
    if (role.company) {
      profile.roles[j].company = role.company._id;
    }

    if (role.unit) {
      if (!(role.unit._id in units)) units[role.unit._id] = role.unit;
      profile.roles[j].unit = role.unit._id;
    }

    if (role.property) {
      if (!(role.property._id in properties)) properties[role.property._id] = role.property;
      profile.roles[j].property = role.property._id;
    }

    if (!(role._id in roles)) roles[role._id] = profile.roles[j];
  });

  
  properties  = _.values(properties);
  units       = _.values(units);
  roles       = _.values(roles);
  
  return {
    properties,
    roles,
    units,
    profile
  };
};



// WEBPACK FOOTER //
// ./src/store/modules/account.js